export const blockIconsPlacesHouse = (
	<span className='material-symbols-outlined'>house</span>
);
